import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const listProjects = () => axios.get(`${API}/projects`).then((r) => r.data);
export const getProject = (id) => axios.get(`${API}/projects/${id}`).then((r) => r.data);
export const deleteProject = (id) => axios.delete(`${API}/projects/${id}`).then((r) => r.data);

export const updateProjectTasks = (id, tasks) =>
  axios
    .put(`${API}/projects/${id}/tasks`, {
      tasks: tasks.map((t) => ({
        id: t.id,
        start_day: t.start_day,
        duration_days: t.duration_days,
        name: t.name,
        corps_etat: t.corps_etat,
        description: t.description,
        is_critical: t.is_critical,
        dependencies: t.dependencies,
      })),
    })
    .then((r) => r.data);

export const projectPdfUrl = (id) => `${API}/projects/${id}/pdf`;
export const projectCsvUrl = (id) => `${API}/projects/${id}/csv`;
export const projectGanUrl = (id) => `${API}/projects/${id}/gan`;

export const submitFeedback = (id, feedback) =>
  axios.post(`${API}/projects/${id}/feedback`, feedback).then((r) => r.data);

export const generateProject = async (projectData, files, userEmail) => {
  const fd = new FormData();
  fd.append("payload", JSON.stringify(projectData));
  if (userEmail) fd.append("user_email", userEmail);
  (files || []).forEach((f) => fd.append("files", f));
  const res = await axios.post(`${API}/projects/generate`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 180000,
  });
  return res.data;
};
